import PropTypes from 'prop-types'
import { Row, Col, Glyphicon } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import styled  from 'styled-components'
import Panel from 'components/Panel'
import Links from './Links'
import InsertLinkForm from './InsertLinkForm'
import InlineLoader from '../InlineLoader'

const InsertForm = styled.div`
  z-index: 50;
  position: absolute;
`

const AddButton = styled.button`
  position: relative;
  background: transparent;
  border: none;
  left: 1.5%;
  margin-bottom: 0.5rem;
  padding: 0;
  min-width: 4rem;

  &:hover {
    color: var(--main-color);
  }
`

const Loader = styled(InlineLoader)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 150px;
`

const LaunchPad = ({
  adminLinks = [],
  isFetching,
  height,
  addLink,
  userLinks = [],
  postLink,
  toggleAddForm,
  updateLink,
  deleteLink,
  registerLinkClick
}) => {
  const icon = <FontAwesome name="sticky-note-o" />
  return (
    <Panel title="Launch Pad" buttons={icon} blue height={height}>
      <Row>
        {isFetching && <Loader />}
        {!isFetching && (
          <AddButton onClick={toggleAddForm}>
            {addLink ? <Glyphicon glyph="minus" /> : <Glyphicon glyph="plus" />}
          </AddButton>
        )}
      </Row>
      {addLink ? (
        <InsertForm>
          <InsertLinkForm
            toggleAddForm={toggleAddForm}
            createUserLink={postLink}
            updateUserLink={updateLink}
            labels={['Name', 'Link']}
          />
        </InsertForm>
      ) : null}
      <Row>
        <Col xs={12} md={6}>
          {!isFetching && (
            <>
              {userLinks.length !== 0 && (
                <Links
                  links={userLinks}
                  updateUserLink={updateLink}
                  deleteLink={deleteLink}
                  registerLinkClick={registerLinkClick}
                />
              )}
              {userLinks.length === 0 && (
                <div
                  className="no-content"
                  style={{
                    textAlign: 'center',
                    position: 'relative',
                    marginTop: '10rem'
                  }}
                >
                  No custom links
                </div>
              )}
            </>
          )}
        </Col>
        <Col xs={12} md={6}>
          {!isFetching && (
            <>
              {adminLinks.length !== 0 && (
                <Links
                  links={adminLinks}
                  adminLink
                  registerLinkClick={registerLinkClick}
                />
              )}
              {adminLinks.length === 0 && (
                <div
                  className="no-content"
                  style={{
                    textAlign: 'center',
                    position: 'relative',
                    marginTop: '10rem'
                  }}
                >
                  No admin links
                </div>
              )}
            </>
          )}
        </Col>
      </Row>
    </Panel>
  )
}

LaunchPad.propTypes = {
  adminLinks: PropTypes.array,
  isFetching: PropTypes.bool,
  height: PropTypes.string,
  addLink: PropTypes.bool,
  userLinks: PropTypes.array,
  postLink: PropTypes.func,
  toggleAddForm: PropTypes.func,
  updateLink: PropTypes.func,
  deleteLink: PropTypes.func,
  registerLinkClick: PropTypes.func
}

export default LaunchPad
